import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import { message } from 'antd';
import PhaserCollageGame from 'src/games/CollageGame/Main';

interface CollageGameProps extends PageProps<{}> {
    onComplete: () => void;
}

class CollageGame extends React.Component<CollageGameProps> {
    game: Phaser.Game = null;
    constructor(props: CollageGameProps) {
        super(props);
        bindAllOfThis(this, CollageGame.prototype);
    }

    completeGame() {
        return message.success("You finished the game!");
    }

    render() {
        return <div>
            <PhaserCollageGame onComplete={this.completeGame}/>
        </div>;
    }
}

export default CollageGame;



// WEBPACK FOOTER //
// ./src/pages/game/CollageGame.tsx